import { render, staticRenderFns } from "./Kasalliktarixi.vue?vue&type=template&id=f95ad016&scoped=true"
import script from "./Kasalliktarixi.vue?vue&type=script&lang=js"
export * from "./Kasalliktarixi.vue?vue&type=script&lang=js"
import style0 from "./Kasalliktarixi.vue?vue&type=style&index=0&id=f95ad016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95ad016",
  null
  
)

export default component.exports